import React, { useState } from 'react';
import { Background, Parallax } from 'react-parallax';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import CtaReturn from '../../atoms/cta-return/cta-return';
import SectionLearnFantasticHour from '../../molecules/section-learn-fantastic-hour/section-learn-fantastic-hour';
import SectionMeetModules from '../../molecules/section-meet-modules/section-meet-modules';
import SectionRadioShowAndForumHeader from '../../molecules/section-radio-show-and-forum-header/section-radio-show-and-forum-header';
import SectionRadioShowAndForumPodcast from '../../molecules/section-radio-show-and-forum-podcast/section-radio-show-and-forum-podcast';
import SectionRadioShowAndForumVideoAndComments from '../../molecules/section-radio-show-and-forum-video-and-comments/section-radio-show-and-forum-video-and-comments';
import './radio-show-and-forum-content.scss';

const RadioShowAndForumContent = ({ contentInfo }) => {

    const { homeLink } = useHomeLinkMode();
    const [videoModal, setVideoModal] = useState(null);

    return (
        <div className="f-o-radio-show-and-forum-content">
            <Parallax
                className="f-o-radio-show-and-forum-content__parallax"
                strength={-1200}>
                <Background className="custom-bg">
                </Background>
            </Parallax>
            <Breadcrumb />
            <CtaReturn textReturn={"Volver al inicio del curso"} redirect={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/")} />
            {videoModal &&
                <>{videoModal}</>
            }
            <SectionRadioShowAndForumHeader contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido15")[0]} />
            <SectionRadioShowAndForumVideoAndComments contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido16")[0]} />
            <SectionLearnFantasticHour contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido10")[0]} setVideoModal={setVideoModal} />
            {contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido17")[0] && <SectionRadioShowAndForumPodcast contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido17")[0]} />}
            <SectionMeetModules contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido7")[0]} />
        </div>
    )
}

export default RadioShowAndForumContent
